import Header from '../../components/common/header/index.vue'
import axios from 'axios'
import { encryptRSA } from '../../util/rsa'
import { validatePasswordStrength } from '../../util/password'
export default {
  name: 'login',
  components: { Header },
  data () {
    // 密码校验
    const validateRegisterPass = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.accountName)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else {
        if (this.resetForm.confirmPassword !== '') {
          this.$refs.resetForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    // 确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.accountName)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      // token
      Authorization: '',
      accountName: '',
      // 重置密码和成功切换
      isReset: false,
      // 重置密码的form对象
      resetForm: {
        password: '',
        confirmPassword: ''
      },
      // 注册的校验规则
      resetRules: {
        password: [
          { validator: validateRegisterPass, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      countdown: 5
    }
  },
  // 创建元素
  mounted () {
    // 安全加固：token 优先从内存 store 取（登录后跳转 /reset 的主流程）
    this.Authorization = this.$store.state.Authorization || ''
    // 兼容保留：历史改密邮件链接若带 ?Authorization= 仍可用（一次性）；
    // 新的主流程已不再把 token 放进 URL
    if (!this.Authorization && this.$route.query.Authorization) {
      this.Authorization = this.$route.query.Authorization
    }
    this.accountName = this.$route.query.name || this.$store.state.name || localStorage.getItem('name') || ''
  },
  // 方法定义
  methods: {
    // 重置密码的校验
    submitReset (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.resetPassword()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    resetPassword () {
      const self = this
      // 盐值
      // const salt = 'cnki-yyds*123.cv987@'
      const data = {
        password: encryptRSA(self.resetForm.password)
      }
      axios.post('/yuhuamenhu/user/resetPassword', data, {
        headers: {
          Authorization: self.Authorization
        }
      }).then(json => {
        if (json.data.code === 200) {
          self.isReset = true
          this.countdown = 5
          this.countDown()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    countDown () {
      if (this.countdown > 1) {
        this.countdown--
        setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.$router.push('/')
      }
    }
  }
}
